import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController, IonContent, ActionSheetController } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StatusBar } from '@capacitor/status-bar';
import { AvatarService } from 'src/app/services/avatar.service';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

@Component({
  selector: 'app-enroute-chat',
  templateUrl: './enroute-chat.component.html',
  styleUrls: ['./enroute-chat.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule]
})
export class EnrouteChatComponent implements OnInit {

  @ViewChild(IonContent) content: IonContent;
  @Input() chatData: any;  // Define an input property to receive data

  newMsg = '';
  messages: Observable<import("@angular/fire/firestore").DocumentData[]>;
  hasNoData: any;
  loading: boolean = true;
  isTyping = false;

  constructor(
    private chatService: AvatarService,
    private router: Router,
    private modalCtrl: ModalController,
    private actionSheetCtrl: ActionSheetController
  ) { }

  async ionViewDidEnter() {
    this.messages = this.chatService.getChatMessage(this.chatData.userId);
    this.messages.subscribe((d) => {
      this.loading = false;
      if (d.length == 0) {
        this.hasNoData = true;
      } else {
        this.hasNoData = false;
        setTimeout(() => this.content.scrollToBottom(300), 300);
      }
    });
  }

  async Show() {
    await StatusBar.setOverlaysWebView({ overlay: false });
  }

  async Hide() {
    await StatusBar.setOverlaysWebView({ overlay: true });
  }

  ngOnInit() {
    // Use the passed data if needed
    console.log(this.chatData);
  }

  async sendMessage() {
    if (!this.newMsg.trim()) return;
    try {
      this.isTyping = true;
      await this.chatService.addChatEnRouteMessage(this.newMsg.trim(), this.chatData.userId);
      this.newMsg = '';
      this.content.scrollToBottom(300);
      await this.chatService.updatChatMessageInfo(this.chatData.userId);
    } catch (e) {
      console.error('Error sending message:', e);
    } finally {
      this.isTyping = false;
    }
  }

  async presentAttachmentOptions() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Share Media',
      buttons: [
        {
          text: 'Camera',
          icon: 'camera',
          handler: () => this.takePhoto(CameraSource.Camera)
        },
        {
          text: 'Gallery',
          icon: 'image',
          handler: () => this.takePhoto(CameraSource.Photos)
        },
        {
          text: 'Voicenote',
          icon: 'mic',
          handler: () => this.recordAudio()
        },
        {
          text: 'Cancel',
          role: 'cancel'
        }
      ]
    });
    await actionSheet.present();
  }

  async takePhoto(source: CameraSource) {
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        source: source
      });

      if (image && image.base64String) {
        this.loading = true;
        const fileName = `img_${Date.now()}.jpg`;
        const url = await this.chatService.uploadChatMedia(image.base64String, this.chatData.userId, fileName);
        await this.chatService.addChatMediaMessage(this.chatData.userId, url, 'image');
        await this.chatService.updatChatMessageInfo(this.chatData.userId);
        this.content.scrollToBottom(300);
      }
    } catch (e) {
      console.error('Error taking photo:', e);
    } finally {
      this.loading = false;
    }
  }

  async recordAudio() {
    console.log('Audio recording not fully implemented - requires plugin');
  }

  playAudio(url: string) {
    const audio = new Audio(url);
    audio.play();
  }

  viewMedia(url: string, type: string) {
    window.open(url, '_blank');
  }

  formatTime(timestamp: any): string {
    if (!timestamp) return '';

    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    const now = new Date();
    const diff = now.getTime() - date.getTime();

    // Less than 24 hours, show time only
    if (diff < 24 * 60 * 60 * 1000) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    // More than 24 hours, show date and time
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' }) +
      ' ' +
      date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  closeChat() {
    this.modalCtrl.dismiss();
  }
}
